var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCriticalAlarmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.85 11.1383H10.475V5.82577C10.475 3.62108 8.8453 1.7992 6.72499 1.49608V0.888268C6.72499 0.542955 6.4453 0.263268 6.09999 0.263268C5.75468 0.263268 5.47499 0.542955 5.47499 0.888268V1.49608C3.35468 1.7992 1.72499 3.62108 1.72499 5.82577V11.1383H1.34999C1.07343 11.1383 0.849991 11.3617 0.849991 11.6383V12.1383C0.849991 12.207 0.906241 12.2633 0.974991 12.2633H4.34999C4.34999 13.2289 5.13437 14.0133 6.09999 14.0133C7.06562 14.0133 7.84999 13.2289 7.84999 12.2633H11.225C11.2937 12.2633 11.35 12.207 11.35 12.1383V11.6383C11.35 11.3617 11.1266 11.1383 10.85 11.1383ZM6.09999 13.0133C5.68593 13.0133 5.34999 12.6773 5.34999 12.2633H6.84999C6.84999 12.6773 6.51405 13.0133 6.09999 13.0133ZM2.84999 11.1383V5.82577C2.84999 4.95702 3.18749 4.14139 3.80155 3.52733C4.41562 2.91327 5.23124 2.57577 6.09999 2.57577C6.96874 2.57577 7.78437 2.91327 8.39843 3.52733C9.01249 4.14139 9.34999 4.95702 9.34999 5.82577V11.1383H2.84999Z",
    fill: "#F5222D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalAlarmIcon);
export default __webpack_public_path__ + "static/media/criticalAlarmIcon.f5e457cea6fcb745dc151cd1a90dfed7.svg";
export { ForwardRef as ReactComponent };